import { CreateForm, WysiwygInput } from 'framework/form';
import type { FormFieldsData } from 'framework/form';
import { BigFormRow, FormButtonsLayout } from 'framework/ui/layout';
import type { TimelineAddFormProps } from 'framework/ViewTypes/embeddable';
import usePositionProfileTimelineService from 'domain/people/positionProfiles/usePositionProfileTimelineService';
import type {
  PositionProfileTimelineNoteValues,
  PositionProfileTimelineEvent,
} from 'domain/people/positionProfiles/types';
import { useParams } from 'react-router-dom';

const NOTE_VALIDATION = {
  note: {
    type: 'string',
    required: true,
  },
};

interface NoteFormProps {
  initialNote?: string | null;
  isCreate: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  submit: (values: PositionProfileTimelineNoteValues) => Promise<PositionProfileTimelineEvent>;
}

const NoteForm = ({ initialNote = '', isCreate, onCancel, onSuccess, submit }: NoteFormProps) => {
  const submitForm = (values: FormFieldsData) => submit({ note: String(values.note ?? '') });

  return (
    <CreateForm
      initialData={{ note: initialNote ?? '' }}
      isCreateRequest={isCreate}
      submitFormFunc={submitForm}
      getValidationSchemaFunc={() => Promise.resolve(NOTE_VALIDATION)}
      afterSubmit={{ execute: onSuccess }}
    >
      <BigFormRow>
        <WysiwygInput source="note" label="" />
      </BigFormRow>
      <FormButtonsLayout onCancelAction={onCancel} actionsSx={{ mt: 1.5 }} />
    </CreateForm>
  );
};

export const PositionProfileTimelineNoteAddForm = ({ onCancel, onSuccess }: TimelineAddFormProps) => {
  const profileId = useParams<{ id: string }>().id!;
  const { createTimelineNote } = usePositionProfileTimelineService();

  return (
    <NoteForm
      isCreate
      onCancel={onCancel}
      onSuccess={onSuccess}
      submit={values => createTimelineNote(profileId, values)}
    />
  );
};
